import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Radio from '@components/Radio';
import Text from '@components/Text';
import TextField from '@components/TextField';
import useAppCustom from '@hooks/useAppCustom';
import useCalculatedRequest from '@store/order/hooks/useCalculatedRequest';
import { orderActions } from '@store/order/orderSlice';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

function OrderNote() {
    const { requestMessages } = useAppCustom().payment;
    const { note } = useCalculatedRequest();
    const dispatch = useDispatch();
    const { t } = useTranslation('order');
    const messages = requestMessages
        .filter((message) => !!message);
    const [isManual, setIsManual] = useState<boolean>(false);
    const updateNote = (v: string) => {
        dispatch(orderActions.setNote(v));
    };
    return (
        <Accordion initialOpen
            title={<Text fontWeight='bold'
                size='lg'>{t('orderNote.title')}</Text>}>
            <Column spacing={16} fullWidth>
                <Column spacing={12} fullWidth>
                    {messages.map((message, index) => (
                        <Radio value={message}
                            key={index.toString()}
                            onChange={(v) => {
                                updateNote(v);
                                setIsManual(false);
                            }}
                            isSelected={note === message && !isManual} >
                            {message}
                        </Radio>
                    ))}
                    <Radio value='선택안함'
                        isSelected={!note && !isManual}
                        onChange={() => {
                            updateNote('');
                            setIsManual(false);
                        }}>
                        {t('orderNote.noSelection')}
                    </Radio>
                    <Radio value='isManual'
                        isSelected={isManual}
                        onChange={() => {
                            setIsManual(true);
                            updateNote('');
                        }} >
                        {t('orderNote.manual')}
                    </Radio>
                    {isManual && (
                        <TextField value={note}
                            placeholder={t('orderNote.placeholder')}
                            as='textarea'
                            rows={3}
                            onChange={(e) => updateNote(e.target.value)} />
                    )}
                </Column>
            </Column>
        </Accordion>
    );
}

export default OrderNote;
